// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useState } from "react";
// import RoleToggle from "../../components/RoleToggle";
// import ItemTab from "./_components/ItemTab";
// import InventoryMangement from "./inventory-mangement";
// import PromoTab from "./_components/PromoTab";

// const InverntoryProduct: React.FC = () => {
//   const roles1 = ["Product", "Promo", "Inventory"];
//   const [activeRole1, setActiveRole1] = useState<string>(
//     () => localStorage.getItem("pickupActiveRole") || "Product"
//   ); 
//   useEffect(() => {
//     localStorage.setItem("pickupActiveRole", activeRole1);
//   }, [activeRole1]);

//   return (
//     <>
//       <div className="p-6 pt-0 space-y-4">
//         <div className="flex justify-between items-center">
//           <h1 className="text-2xl text-[#212121] tracking-[-0.5px] ">
//             Inventory Management
//           </h1>
//           <RoleToggle
//             options={roles1}
//             active={activeRole1}
//             onChange={setActiveRole1}
//           />
//         </div>

//         {activeRole1 === "Product" && <ItemTab />}
//         {activeRole1 === "Promo" && <PromoTab />}
//         {activeRole1 === "Inventory" && <InventoryMangement />}
//       </div>
//     </>
//   );
// };

// export default InverntoryProduct;




import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { usePermissionTabs } from "../../hooks/usePermissionTabs";
import RoleToggle from "../../components/RoleToggle";
import InventoryMangement from "./inventory-mangement";
import ProductDemo from "../ProductDemo/product-demo";

const InverntoryProduct: React.FC = () => {
  const data = useSelector((state: any) => state?.product?.data);

  const inventoryStats = useMemo(() => {
    const total = data?.total || data?.productItems?.length || 0;
    const active =
      data?.productItems?.filter(
        (p: any) => (p?.status || "").toUpperCase() === "ACTIVE",
      ).length || 0;
    const inactive = data?.productItems
      ? data.productItems.filter(
          (p: any) => (p?.status || "").toUpperCase() !== "ACTIVE",
        ).length
      : Math.max(0, total - active);
    const categories =
      new Set(data?.productItems?.map((p: any) => p?.category)).size || 0;

    return { total, active, inactive, categories };
  }, [data]);

  const ALL_TABS = [
    {
      key: "product",
      label: "Product",
      component: <ProductDemo activeTabExternal="catalog" />,
      modules: ["products"],
      operation: "read",
    },
    {
      key: "inventory",
      label: "Inventory",
      component: <InventoryMangement />,
      modules: ["shipment_inventory", "product_inventory"], 
      operation: "read",
    },
  ];

  const result = usePermissionTabs({
    tabs: ALL_TABS,
    param: "tab",
  });

  if (result.isLoading || !result.permissionsReady) {
    return (
      <div className="px-6 space-y-4">
        <div className="bg-white rounded-xl p-6">
          <div className="h-64 bg-gray-100 rounded animate-pulse" />
        </div>
      </div>
    );
  }

  if (result.error || result.visibleTabs.length === 0) {
    return (
      <div className="p-6 text-center text-gray-500">
        {result.error ? "Failed to load permissions." : "You don't have access to this section"}
      </div>
    );
  }

  return (
    <div className="px-4 space-y-4" style={{ fontFamily: '"Inter Tight", sans-serif' }}>
      {/* Tab row — matches admin layout */}
      <div className="flex justify-between items-center flex-wrap lg:flex-nowrap w-full pr-3">
        <div className="flex items-center gap-4 flex-wrap lg:flex-nowrap">
          <RoleToggle
            options={result.visibleTabs.map((t) => t.label)}
            active={result.activeLabel}
            onChange={result.handleChange}
            containerClassName="inline-flex items-center gap-2.5 rounded-lg bg-gradient-to-b from-white/20 to-white/60 backdrop-blur-xl transition-all duration-300 py-1 px-1.5 overflow-x-auto hide-scrollbar max-w-full shadow-inner border border-gray-300"
            activeClassName="bg-black text-white font-bold shadow-sm"
            inactiveClassName="bg-transparent text-[#212121]/70 font-bold"
          />
        </div>
        <div className="flex items-center gap-3 bg-white px-4 py-1.5 rounded-lg border border-slate-200 shadow-sm text-xs select-none font-semibold h-8">
          <div className="flex items-center gap-1.5">
            <span className="text-slate-500">Total:</span>
            <span className="text-blue-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded-md font-bold">
              {inventoryStats.total}
            </span>
          </div>
          <span className="h-3 w-px bg-slate-200" />
          <div className="flex items-center gap-1.5">
            <span className="text-slate-500">Active:</span>
            <span className="text-green-700 bg-green-50 border border-green-100 px-1.5 py-0.5 rounded-md font-bold">
              {inventoryStats.active}
            </span>
          </div>
          <span className="h-3 w-px bg-slate-200" />
          <div className="flex items-center gap-1.5">
            <span className="text-slate-500">Categories:</span>
            <span className="text-purple-700 bg-purple-50 border border-purple-100 px-1.5 py-0.5 rounded-md font-bold">
              {inventoryStats.categories}
            </span>
          </div>
          <span className="h-3 w-px bg-slate-200" />
          <div className="flex items-center gap-1.5">
            <span className="text-slate-500">Inactive:</span>
            <span className="text-rose-700 bg-rose-50 border border-rose-100 px-1.5 py-0.5 rounded-md font-bold">
              {inventoryStats.inactive}
            </span>
          </div>
        </div>
      </div>

      <div>
        {result.content}
      </div>
    </div>
  );
};

export default InverntoryProduct;